// 브라우저 진입점 — React 뿌리를 심고 등록 계층이 고른 화면을 그린다
//
// 이 파일은 **얇게 둔다.** 뒤 스텝들이 화면을 더할 때 이 파일을 열지 않고
// src/web/routes.registry.tsx 의 자기 슬롯만 채우게 하는 것이 이 구조의 목적이다.
// 여기에 화면별 조건이 쌓이기 시작하면 그 목적이 바로 무너진다.

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { resolveScreen } from './routes.registry.tsx'
import { markScrollbar } from './shell/scrollbar.ts'

function App(): React.ReactElement {
  // 주소창 경로로 화면을 고른다. 히스토리 조작이 필요해지는 것은 화면이 둘 이상이
  // 되는 T2 부터이고, 그때 이 자리에 상태 하나가 들어온다.
  return resolveScreen(window.location.pathname).render()
}

const container = document.getElementById('root')
if (container === null) {
  throw new Error('#root 가 없다 — src/web/index.html 이 바뀌었는지 확인할 것')
}

// 화면 하나의 조건이 아니라 모든 화면의 문서 폭에 걸리는 표시라 여기서 한 번 단다(이유는 그 파일 머리).
markScrollbar(document)

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
